Backbone = require("backbone")
# sound middleware that uses newer web audio api
sounds  = {}
timers  = {}
enabled = true
_AudioContext = window.AudioContext or window.webkitAudioContext
_firstSoundPlayed = false
onPlayEmpty = []
# keep a list of all buffersources created so we can stop them at any time
sources = {}
_sharedContext = null

userInteractionEvents = ["click", "touchend", "touchstart"]

unmuteAudioInIos = require("unmute_ios_audio")

# Subscribe to when a video is played
Backbone.Events.on "publish", (event) ->
  if event.command is "video-play"
    console.log('unmute from video play')
    unmuteAudioInIos()

###*
 * Returns a shared instance of the Audio Context.
 * This needs to be wrapped to fix an iOS webkit issue where video playback
 * corrupts the audio context resulting in distorted audio. Fixes ED-6076.
 * @see {@link https://bugs.webkit.org/show_bug.cgi?id=168165}
 * @see {@link https://bugs.webkit.org/show_bug.cgi?id=154538}
 * @returns {Promise} Promise object with the shared audio context
###
getSharedAudioContext = -> new Promise (resolve, reject) ->
  if not _sharedContext?
    console.log('unmute from getSharedAudioContext')
    unmuteAudioInIos()
    _sharedContext = new _AudioContext

  resolve _sharedContext

getPath = (name) ->
  name = name.replace("system:", "audio/")
  if name.match /\.[^\.]+$/ then name else "#{name}.mp3"

loadAudio = (path) ->
  cancelled = false
  cancel = -> cancelled = true
  isCancelled = -> cancelled
  promise = new Promise (resolve, reject) ->
    req = new XMLHttpRequest()
    req.open 'GET', path, true
    req.responseType = 'arraybuffer'
    req.onload  = ->
      if cancelled
        reject("sound cancelled")
      else
        getSharedAudioContext().then (context) ->
          context.decodeAudioData req.response, resolve, reject
    req.onerror = -> reject("load error")
    req.send()
  return { promise, cancel, isCancelled }

getLastAudio = (name) ->
  new Promise (resolve, reject) ->
    if sources[name]? and sources[name].length > 0
      resolve(sources[name][sources[name].length - 1])
    else
      reject("no audio playing")

getAudio = (name, from = sounds) ->
  if name.match("system:")
    from[name] = loadAudio(getPath(name)) if enabled
  else
    from[name] = loadAudio(getPath(name))

  # return empty result if nothing is ready
  if !from[name]?
    return null

  return from[name].promise.then (buf) ->
    if from[name].isCancelled()
      throw new Error "sound cancelled"
    return getSharedAudioContext().then (context) ->
      bufferSource        = context.createBufferSource()
      gain                = context.createGain()
      bufferSource.buffer = buf
      bufferSource.connect(gain)
      gain.connect(context.destination)
      sources[name] ?= []
      sources[name].push({ bufferSource, gain })
      return { bufferSource, gain }

preload = (path, id, cb = ->) ->
  if _firstSoundPlayed
    getAudio(path)
    cb()
  else
    onPlayEmpty.push { path, id, cb }

playEmpty = (cb = ->) ->
  getSharedAudioContext().then (context) ->
    if _firstSoundPlayed is true
      return cb()
    else
      # prevent audio from playing that was loaded
      # before any user gesture occurred
      stopAll()

      _firstSoundPlayed = true

      buf       = context.createBuffer(2, 22050, 44100)
      bs        = context.createBufferSource()
      bs.buffer = buf
      bs.connect(context.destination)
      bs.start()
      preload(path, id, cb) for { path, id, cb } in onPlayEmpty
      cb()
  .catch (err) ->
    console.warn('sound error', err)

# Get permission to play sounds on first tap for iOS & Android
getPermission = ({ type }) ->
  for ev in userInteractionEvents
    window.removeEventListener ev, getPermission, true
    
  playEmpty()

for ev in userInteractionEvents
  window.addEventListener ev, getPermission, true

progressInterval = null
playOpts = ({ clearTimer, source }) -> (name, cb = ->) ->
  sourceP = if source?
    new Promise (resolve, reject) -> resolve(source)
  else
    getAudio(name)

  # do nothing if we can't find source
  if !sourceP?
    cb { name }
    return

  _firstSoundPlayed = true
  ended = false
  sourceP.then ({ bufferSource }) ->
    window.clearTimeout timers[name] if clearTimer

    if not _.isFunction(cb)
      { onProgress, onComplete, cb } = cb
      startTime = Date.now()
      duration = bufferSource.buffer.duration * 1000
      onTimeUpdate = ->
        if ended
          window.clearInterval(progressInterval)
        else
          progress = (Date.now() - startTime) / duration
          progress = Math.min(progress, 1.0)
          onProgress(progress)
      bufferSource.onended = ->
        ended = true
        onProgress(1) if onProgress?
        onComplete() if onComplete?

      window.clearInterval(progressInterval) if progressInterval?
      window.setInterval onTimeUpdate, 20

    bufferSource.start(0)

    cb { name }
  .catch (err) ->
    console.error('get audio err ', err)

play = (name, cb = ->) ->
  getSharedAudioContext().then (context) ->
    context.resume()
    
    playOpts({ clearTimer: true })(name, cb)

loup = (name, cb = ->) ->
  source = getAudio(name)
  if !source?
    cb()
    return

  source.then ({ bufferSource, gain }) ->
    duration = bufferSource.buffer.duration * 1000

    return unless duration > 0

    window.clearTimeout timers[name]

    firstTime = true
    do repeat = ->
      # only re-use the bufferSource the first loup
      if firstTime
        playOpts(clearTimer: false, source: { bufferSource, gain })(name)
        firstTime = false
      else
        playOpts(clearTimer: false)(name)
      timers[name] = window.setTimeout(repeat, duration)

    cb()


fadeIn = (name, ms = 2000, increment = 0.05) ->
  loup name, ->
    getLastAudio(name).then ({ bufferSource, gain }) ->
      gain.gain.value = 0
      do repeat = ->
        gain.gain.value = Math.max((gain.gain.value or 0.0) + increment, 0)
        if gain.gain.value < 1
          window.setTimeout(repeat, ms * increment)
    .catch (err) ->
      console.warn('get audio err ', err)


fadeOut = (name, ms = 2000, increment = 0.05) ->
  getLastAudio(name).then ({ bufferSource, gain }) ->
    msElapsed = 0

    do repeat = ->
      msElapsed += increment * ms
      gain.gain.value = Math.max((gain.gain.value or 1.0) - increment, 0)

      if msElapsed < ms
        window.setTimeout(repeat, ms * increment)
      else
        window.clearTimeout timers[name]
        try
          bufferSource.stop()
  .catch (err) ->
    console.warn('get audio err ', err)

stopAll = ->
  for name, sourceList of sources
    sounds[name]?.cancel?()
    for { bufferSource, gain } in sourceList
      try
        bufferSource.stop()
    sources[name] = []
    window.clearTimeout timers[name]

stop = (name, cb = ->) ->
  window.clearTimeout timers[name]
  sounds[name]?.cancel?()
  for { bufferSource, gain } in (sources[name] or [])
    try
      bufferSource.stop()
  sources[name] = []
  cb()

pause = ->
  getSharedAudioContext().then (context) ->
    context.suspend().then () ->
      console.log('suspended')
    .catch (err) ->
      console.error('suspend error', err)

resume = ->
  getSharedAudioContext().then (context) ->
    context.resume().then () ->
      console.log('resumed')
    .catch (err) ->
      console.error('resume error', err)

disableSystemSounds = ->
  enabled = false

firstSoundPlayed = (cb) ->
  getSharedAudioContext().then (context) ->
    console.log('firstSoundPlayed state = ', context.state)
    cb(null, _firstSoundPlayed)

commands = (next) ->
  {
    preload
    stop
    play
    pause
    resume
    stopAll
    fadeIn
    fadeOut
    disableSystemSounds
    loop:   loup
    stopId: stop
    playId: play
    loopId: loup
    playEmpty
    firstSoundPlayed
  }

module.exports = {
  type: "sound"
  commands
}
